export default __webpack_public_path__ + "static/media/livingroom.5631c33b.jpg";